import { useState } from 'react';

import { VFlex, VInput, VStack, VTextButton } from '@/package';
import type { User, UserGroup } from '@/type';

import { UserProfileChangeGroupModal } from './UserProfileChangeGroupModal';

export const ChangeGroup = ({
  groupList,
  selectedUser,
  isUserEditable,
}: {
  groupList: UserGroup[];
  selectedUser: User;
  isUserEditable: boolean;
}) => {
  const [visible, setVisible] = useState(false);
  const onUserGroupChangeClick = () => {
    setVisible(true);
  };
  const userGroups =
    groupList?.filter(g => g.users.find(u => u.id === selectedUser?.id)) ?? [];
  const [userGroup, setUserGroup] = useState<UserGroup[]>(userGroups);

  return (
    <>
      <VStack gap={0.25} className="w-full">
        <VInput
          fluid
          label="Group"
          value={userGroups?.map(g => g.name).join(', ')}
          readOnly={!isUserEditable}
        />
        {isUserEditable && (
          <VFlex className="w-full" justify="end">
            <VTextButton size="md" onClick={() => onUserGroupChangeClick()}>
              Change group
            </VTextButton>
          </VFlex>
        )}
      </VStack>

      <UserProfileChangeGroupModal
        groupList={groupList}
        selectedUser={selectedUser}
        visible={visible}
        setVisible={setVisible}
        userGroup={userGroup}
        setUserGroup={setUserGroup}
      />
    </>
  );
};
